const { cELM, unique, Wrap4Arrow } = require("../../utils");
const Chat = require("../../chat");

class ContinueArrow {
  constructor(data) {
    this._data = data;
    this.options = unique(this._data.values.split("|"));
    this.element = cELM("div", "option-block");
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    const _self = this;
    const btnEl = cELM("div", "continue-button", _self.options[0]);
    const btnWrp = Wrap4Arrow(btnEl);
    btnEl.classList.add("continue-button-active");
    btnWrp.classList.add("arrow-active");
    this.element.addELM(btnWrp);

    btnEl.onclick = function(evt) {
      Chat.default.send({ text: _self.options[0], id: _self._data.id }, null, _self.element);
    };

    return this.element;
  }

  reset() {
    let sibling = this.element.firstChild;
    while (sibling) {
      sibling.classList.remove("option-active");
      sibling = sibling.nextSibling;
    }
    this.selectedOptions = [];
  }

  focus() {}
}

module.exports = ContinueArrow;
